export enum HiddenMessageIdPrefix {
    HIDDEN = 'hidden-',
    CONVERSATION_RESUME = 'conversation-resume-',
    MEMORY_UPDATE = 'memory-update-',
}
